export const featureFlagsTabs = {
  featureFlags: "Feature Flags",
  googleReview: "Google Review",
  inboxPath: "inbox",
  aiReply: "AI Reply",
};

export const featureFlagsReduxConstants = {
  UPDATE_FEATURE_FLAG_FOR_BRAND: "UPDATE_FEATURE_FLAG_FOR_BRAND",
  GET_ALL_BRANDS_FOR_FEATURE_FLAGS: "GET_ALL_BRANDS_FOR_FEATURE_FLAGS",
};

export const featureFlagStatusConstants = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};

export const featureFlagStatusOptions = [
  {
    value: featureFlagStatusConstants.ACTIVE,
    label: "Active",
  },
  {
    value: featureFlagStatusConstants.INACTIVE,
    label: "Inactive",
  },
];

export const googleSocialLinkStatusOptions = [
  { value: "googleSocialLink != null", label: "Active" },
  { value: "googleSocialLink = null", label: "Inactive" },
];

// Constants for feature flag default dropdown
export const featureDropdownOptions = [
  {
    value: 1,
    label: "Inbox",
  },
  {
    value: 3,
    label: "AI Reply",
  },
  {
    value: 2,
    label: "InStore",
  },
  {
    value: 4,
    label: "NPS First",
  },
];

export const aiReplyReduxConstants = {
  GET_BRAND_SOCIAL_LINKS: "GET_BRAND_SOCIAL_LINKS",
  RESET_BRAND_SOCIAL_LINKS: "RESET_BRAND_SOCIAL_LINKS",
  UPDATE_BRAND_SOCIAL_LINKS: "UPDATE_BRAND_SOCIAL_LINKS",
  GET_ALL_BRANDS_FOR_AI_REPLY: "GET_ALL_BRANDS_FOR_AI_REPLY",
};

export const socialLinkConstants = {
  MAX_LINK_LENGTH: 1000,
  LINK_LIMIT_ERROR: "Link cannot exceed 1000 characters",

  FACEBOOK_URL_PATTERN:
    /^(https?:\/\/)(www\.)?(facebook\.com|fb\.com)\/?[^\s]*$/,
  INSTAGRAM_URL_PATTERN: /^(https?:\/\/)(www\.)?instagram\.com\/?[^\s]*$/,
  WEBSITE_URL_PATTERN: /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}\/?[^\s]*$/,

  WEBSITE_URL_ERROR: "Enter a valid website URL",
  FACEBOOK_URL_ERROR: "Enter a valid Facebook URL",
  INSTAGRAM_URL_ERROR: "Enter a valid Instagram URL",
};

export const VALIDATION_TYPES = {
  MAX_LENGTH: "maxLength",
};

export const featureFlagsUi = {
  SEARCH_DEBOUNCE_MS: 1000,
  SELECT_MENU_MAX_HEIGHT_PX: 200,
};

export const socialLinkPlatformEnum = {
  Facebook: 2,
  Instagram: 1,
  BrandWebsite: 3,
};
